import useSWR from 'swr';
import { useAppStore } from '@/stores';
import { supabaseClient } from '@/lib/supabase/client';
import { CommissionAccessError, type CommissionAccess } from '@/lib/app/commission-access';

export async function getCommissionAccess(companyId: number): Promise<CommissionAccess> {
  const { data, error } = await supabaseClient.rpc('commission_access_scope', { target_company_id: companyId });
  if (error) throw new CommissionAccessError(error);
  return data as CommissionAccess;
}

export function useCommissionAccess() {
  const user = useAppStore(state => state.currentUser);
  return useSWR(user && (user.company?.product_access_commissions || user.role === 'super_admin' || user.is_super_admin) ? ['commission-access', user.id, user.company_id] : null,
    ([, , companyId]) => getCommissionAccess(Number(companyId)), {
      revalidateOnFocus: true,
      shouldRetryOnError: (error: CommissionAccessError) => error.retryable !== false,
    });
}
